






























import {
	defineComponent,
	Ref,
	ref,
} from '@vue/composition-api';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import { useDigestsStore } from '../store/GroupDigests';
import DigestForm from './DigestForm.vue';
import { DigestFormOutput } from './digestForm';

export default defineComponent({
	components: {
		SlidingPanel,
		DigestForm,
		ErrorCard,
		SuccessCard,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		isOpen: Boolean,
	},
	setup(props) {
		// Submission
		const newlyCreatedDigestId: Ref<null | string> = ref(null);
		const {
			track: trackSubmission,
			isLoading: isSavingDigest,
			isError: isErrorSavingUpdates,
			isSuccess: isSuccessSavingUpdates,
		} = useAsyncStatus();
		const submit = async (payload: DigestFormOutput) => {
			newlyCreatedDigestId.value = null;
			newlyCreatedDigestId.value = await trackSubmission(useDigestsStore().create(props.groupId, payload));
		};

		return {
			// Edit submission
			submit,
			isSavingDigest,
			isErrorSavingUpdates,
			isSuccessSavingUpdates,
		};
	},
});
